import request from "@/utils/request";
export default {
  // 分页查询Farm列表
  getFarmData: (param) => {
    return request({
      url: `/rmc/protein/farm/list`,
      method: "post",
      data: param,
    });
  },
  // 查询ASL Group
  getAslGroupList: (sponsor) => {
    return request({
      url: `/rmc/protein/asl/aslGroupList?sponsor=${sponsor}`,
      method: "post",
      data: {},
    });
  },
  // 获取sponsor
  getSponsorByUser: () => {
    return request({
      url: `/rmc/protein/medicine/getSponsorByUser`,
      method: "post",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // 农场明细
  getFarmDetail: (rmcProteinFarmId) => {
    return request({
      url: `/rmc/protein/farm/detail/${rmcProteinFarmId}`,
      method: "post",
      data: {},
    });
  },
  // 根据ASL group获取养殖模式
  getBreedingModeByAslGroup: (param) => {
    return request({
      url: `/rmc/protein/farm/breedingModeList`,
      method: "get",
      params: param
    })
  },
  // 获取授权的Category3
  getAuthorizedCategory3: () => {
    return request({
      url: `/rmc/protein/farm/authorizedCategory3`,
      method: "get",
    });
  },
  // 新增
  addFarm: (param) => {
    return request({
      url: `/rmc/protein/farm/create`,
      method: "post",
      data: param,
    });
  },
  // 更新
  updateFarm: (rmcProteinFarmId, param) => {
    return request({
      url: `/rmc/protein/farm/update/${rmcProteinFarmId}`,
      method: "post",
      data: param,
    });
  },
  // 提交
  submitFarm: (rmcProteinFarmId, param) => {
    return request({
      url: `/rmc/protein/farm/submit/${rmcProteinFarmId}`,
      method: "post",
      data: param,
    });
  },
  // 批量提交
  submitBtach: (param) => {
    return request({
      url: `/rmc/protein/farm/submit`,
      method: "post",
      data: param,
    });
  },
  // 1/2方验证审核维护(10=1方，20=2方)
  partyAuditUpdate: (param, party) => {
    return request({
      url: `/rmc/protein/farm/partyAuditUpdate/${party}`,
      method: "post",
      data: param,
    });
  },
  // 文件描述提交
  updateDocComments: (param) => {
    return request({
      url: `/file/updateDocComments`,
      method: "post",
      data: param,
    });
  },
  // Farm批准
  approveFarm: (param) => {
    return request({
      url: `/rmc/protein/farm/approve`,
      method: "post",
      data: param,
    });
  },
  // Farm退回
  returnFarm: (param) => {
    return request({
      url: `/rmc/protein/farm/return`,
      method: "post",
      data: param,
    });
  },
  // Farm确认无更新
  confirmNoChange: (param) => {
    return request({
      url: `/rmc/protein/farm/confirmNoChange`,
      method: "post",
      data: param,
    });
  },
  // Farm删除
  deleteFarm: (param) => {
    return request({
      url: `/rmc/protein/farm/delete`,
      method: "post",
      data: param,
    });
  },
  // 更新日志列表
  updateLog: (param) => {
    return request({
      url: `/rmc/protein/farm/updateLog`,
      method: "post",
      data: param,
    });
  },
  // 导出更新日志
  downloadUpdateLogList: (param) => {
    return request({
      url: `/rmc/protein/farm/downloadUpdateLogList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出
  downloadFarmLists: (param) => {
    return request({
      url: `/rmc/protein/farm/downloadFarmList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 1/2方验证审核报告列表[[party=10(1方)，party=20(2方)]]
  getPartyAuditReportList: (party, id) => {
    return request({
      url: `/rmc/protein/farm/partyAuditReportList/${party}/${id}`,
      method: "get",
    });
  },
  // 批量上传1/2方验证审核报告
  uploadPartyAuditReport: (param) => {
    return request({
      url: `/rmc/protein/farm/uploadPartyAuditReport`,
      method: "post",
      data: param,
    });
  },
  // 审核报告下载
  downloadPartyAuditReport: (param) => {
    return request({
      url: `/rmc/protein/farm/downloadPartyAuditReport`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出季度审核员清单
  downloadFarmQuarterList: (param) => {
    return request({
      url: `/rmc/protein/farm/downloadFarmQuarterList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
};
